import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { RegistrationEmployeeView } from 'views/registration-employee';

export const RegistrationEmployee = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.registrationEmployee',
    });

    return (
        <>
            <CustomHeader title={t('title')} />
            <RegistrationEmployeeView />
        </>
    );
};
